var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"moderation_header"},[_c('h1',{staticClass:"moderation_header__h1"},[_vm._v("Модерация")]),_c('div',{staticClass:"moderation_header__tabs"},[_c('div',{staticClass:"tab_button",class:{
			"tab_button--selected": _vm.selectedTab === "bans"
		},on:{"click":function($event){return _vm.$router.push("bans")}}},[_vm._v(" Блокировки ")]),_c('div',{staticClass:"tab_button",class:{
			"tab_button--selected": _vm.selectedTab === "reports"
		},on:{"click":function($event){return _vm.$router.push("reports")}}},[_vm._v(" Жалобы ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }